import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import * as title from "../../../constants/titles";
import NavigationBarContainer from "../NavigationBarContainer";
import VentilstillingExcel from "./VentilstillingExcel";
import VentilstillingFilterContainer from "./VentilstillingFilterContainer";
import VentilstillingList from "./VentilstillingList";

function VentilstillingPage() {
  const ventilstillingerSubmittedForm = useSelector(
    (state) => state.submittedForms.ventilstillingerSubmittedForm,
  );
  const ventilstillinger = useSelector((state) => state.ventilstillinger);

  useEffect(() => {
    document.title = title.rapporter.ventilstillingskontroll;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const antallVentilstillinger = Array.isArray(ventilstillinger) ? ventilstillinger.length : 0;

  return (
    <Container fluid>
      <Row>
        <Col>
          <NavigationBarContainer page="ventilstillingskontroll" />
          <div className="rapportSearch">
            <VentilstillingFilterContainer />
          </div>
          <div
            className="rapport-buttons-container"
            style={{
              display: "flex",
            }}
          >
            <div>
              <VentilstillingExcel
                ventilstillingerSubmittedForm={ventilstillingerSubmittedForm}
                ventilstillinger={ventilstillinger}
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "flex-end",
                fontWeight: "bold",
                marginTop: "auto",
              }}
            >
              {antallVentilstillinger} ventilstillinger
            </div>
          </div>
          <div className="rapport-table">
            <VentilstillingList
              ventilstillinger={ventilstillinger}
              id="ventilstillingDiv"
            />
          </div>
        </Col>
        <div style={{ height: 28 }} />
      </Row>
    </Container>
  );
}

export default VentilstillingPage;
